import { Component, OnInit, EventEmitter, Output, Input, ChangeDetectionStrategy } from '@angular/core';
import { Product } from 'src/app/modals/product.model';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CartService } from 'src/app/components/shared/services/cart.service';
import { ProductService } from 'src/app/components/shared/services/product.service';
import { ConfigService } from 'src/app/components/shared/services/config.service';
import { ProductDialogComponent } from 'src/app/components/shop/products/product-dialog/product-dialog.component';
import { Cart1Service } from '../services/cart1.service';
import { SwiperConfig } from '../directive/swiper.directive';

@Component({
    selector: 'app-pack-carousel',
    templateUrl: './pack-carousel.component.html',
    styleUrls: ['./pack-carousel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PackCarouselComponent implements OnInit {
  @Output() onOpenProductDialog: EventEmitter<any> = new EventEmitter();
  @Input('products') products: Array<any>;
  public config: SwiperConfig = {};
  contentLoaded = false;
  constructor(
    public configService: ConfigService,
    private dialog: MatDialog,
    private router: Router,
    public cart1Service: Cart1Service,
    private productService: ProductService
    ) {}

  ngOnInit() {
    setTimeout(() => {
      this.contentLoaded = true;
    }, 3000);
  }
  ngAfterViewInit(){
    this.config = {
      observer: true,
      slidesPerView: 1,
      spaceBetween: 16,
      keyboard: true,
      navigation: true,
      pagination: false,
      grabCursor: true,
      loop: false,
      // Swiper 4 breakpoints were max-width, Swiper 12's are min-width: same ranges re-expressed (GX-7106).
      breakpoints: {
        481: { slidesPerView: 2 },
        741: { slidesPerView: 3 },
        961: { slidesPerView: 4 },
        1281: { slidesPerView: 5 }
      }
    };
  }


openProductDialog(product){
    this.dialog.open(ProductDialogComponent, {
        data:{data: product,
        service: this.cart1Service},
        panelClass: 'product-dialog',
        autoFocus:false
    });
  }

   // Add to cart
   public addToCart(product: any) {
    this.cart1Service.addToCart(product, true, '', false, false, true, true);
  }
}




